import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import skTranslations from './locales/sk/translation.json'
import csTranslations from './locales/cs/translation.json'
import { language } from '../global'

const resources = {
  sk: {
    translation: skTranslations,
  },
  cs: {
    translation: csTranslations,
  },
}

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'sk',
  lng: language,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
